import cx from "classnames";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToastTypes, withToast } from "../../contexts/toastr.context";
import { CommunityService } from "../../_service";

import { useAppService } from "../../hooks/use-app-service";
import {
  getCommunityAddress,
  MAIN_DOMAIN_SUFFIX,
} from "../../_config/helper.config";
import UIcon from "../uicon-component";

function SideCommunitySwitcherComponent({
  user,
  community,
  addToast,
  isVisible = false,
  setSidebarIgnoresCommunitySwitcher = (e) => {},
}) {
  const [isLoadingCommunities, setIsLoadingCommunities] = useState(false);
  const [subscribedCommunities, setSubscribedCommunities] = useState([]);
  // get the community list
  useEffect(() => {
    if (user) {
      setIsLoadingCommunities(true);
      CommunityService.getSubscribedCommunity(user)
        .then((response) => {
          setSubscribedCommunities(response.communities);
          setIsLoadingCommunities(false);
        })
        .catch((error) => {
          addToast("Could not fetch communities!", "", ToastTypes.danger);
          console.log(error);
        });
    }
  }, []);

  // set switcher to be ignored or not
  useEffect(() => {
    setSidebarIgnoresCommunitySwitcher(subscribedCommunities.length < 2);
  }, [subscribedCommunities.length, setSidebarIgnoresCommunitySwitcher]);

  if (isLoadingCommunities) {
    return (
      <div className="SideCommunitySwitcher rounded">
        <div className="w-full animate-pulse">
          <div className="theme-bg-surface w-full h-screen"></div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={cx("SideCommunitySwitcher rounded theme-bg-surface", {
        open: isVisible,
      })}>
      {/* subscribed community list */}
      <div className="sidecommunity-list rounded theme-bg-surface">
        {subscribedCommunities.length > 0 ? (
          subscribedCommunities.map((subscribedCommunity) => (
            <CommunityButton
              key={subscribedCommunity.id}
              user={user}
              active={subscribedCommunity.id === community.id}
              community={subscribedCommunity}
            />
          ))
        ) : (
          <div className="p-4 rounded w-96 mb-4"></div>
        )}
        {/* create community button */}
        <a
          href={`https://app${MAIN_DOMAIN_SUFFIX}`}
          title={`${community.name}: ${getCommunityAddress(community)}`}
          className={cx(
            "CommunityButton theme-bg-disable flex justify-center items-center hover:shadow-lg rounded w-12 h-12 mb-4 cursor-pointer"
          )}>
          {/* <img
                        src={plusIcon}
                        className="w-6 h-6 rounded flex-shrink-0"
                        alt={"New Community"} /> */}
          <UIcon icon="plus" size="lg" className="theme-text-subtitle-1" />
        </a>
      </div>
    </div>
  );
}

function CommunityButton({ user, community, active = false }) {
  const { analyticsService } = useAppService();

  // check if the image has error
  const [imageHasError, setImageHasError] = useState(false);

  return (
    <a
      href={`https://${getCommunityAddress(community)}`}
      onClick={(e) => {
        e.preventDefault();

        // mix panel tracking
        analyticsService.track("select-community", {}, (e) => {
          window.location.href = `https://${getCommunityAddress(
            community
          )}?token=${user.token}`;
        });
      }}
      title={`${community.name}: ${getCommunityAddress(community)}`}
      className={cx(
        "CommunityButton flex hover:shadow-lg rounded w-12 h-12 mb-4 cursor-pointer",
        {
          active: active,
        }
      )}>
      {/* community logo */}
      {community.logo && !imageHasError ? (
        <img
          src={community.logo}
          className="w-12 h-12 rounded mr-2 flex-shrink-0"
          alt={community.name + " Logo"}
          onError={(e) => {
            setImageHasError(true);
          }}
        />
      ) : (
        <svg
          className="theme-bg-surface rounded flex-shrink-0 w-12 h-12"
          style={{
            backgroundColor: "#028FDB",
            color: "white",
          }}>
          <text
            x="50%"
            y="50%"
            fontSize="21"
            fontWeight="bold"
            textAnchor="middle"
            fill="white"
            dominantBaseline="middle">
            {getCommunityInitials(community.name)}
          </text>
        </svg>
      )}
    </a>
  );
}

/**
 * get community initials from community name
 */
function getCommunityInitials(communityName) {
  return communityName
    .split(" ")
    .map((word) => word[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

const SideCommunitySwitcher = withToast(
  connect((s) => ({
    community: s.community,
    user: s.auth,
  }))(SideCommunitySwitcherComponent)
);

export default SideCommunitySwitcher;
